/**
 * Module Staff #04 — Contrats & runs récurrents
 */
const moduleStaffContrats = {
  id: 'staff-contrats-runs',
  population: 'staff',
  order: 4,
  category: 'Commercial',
  title: 'Contrats & runs récurrents',
  subtitle: 'Construire et piloter les contrats-cadres B2B',
  icon: 'FileText',
  duration: '30 min',
  level: 'Avancé',
  audience: 'Commerciaux seniors, direction',
  slides: [
    { type: 'cover', eyebrow: 'Module 04 — Staff', title: 'Contrats & runs', subtitle: 'Sécuriser le CA récurrent avec des contrats-cadres', icon: 'FileText', duration: '30 min', audience: 'Direction commerciale', level: 'Avancé' },
    { type: 'intro', title: 'Objectifs', intro: 'Les contrats-cadres représentent 60-70 % du CA Baobab. Ce module vous donne les bonnes pratiques de structuration et de pilotage.', objectives: [
      'Comprendre l\'anatomie d\'un contrat-cadre (volume, tarif, SLA, durée)',
      'Construire une grille tarifaire dégressive',
      'Définir les SLA et les pénalités contractuelles',
      'Gérer les runs (opérations exécutées sous contrat)',
      'Anticiper le renouvellement à J-60',
      'Gérer les avenants en cours de contrat',
    ]},
    { type: 'concept', eyebrow: 'Structure', icon: 'BookOpen', title: 'Les 5 blocs d\'un contrat-cadre',
      bullets: [
        '📋 Périmètre : trajets, types véhicules, marchandises',
        '📊 Volume : minimum mensuel + plafond (au-delà = spot)',
        '💰 Tarif : grille dégressive selon volume cumulé',
        '⏱️ SLA : taux de service ≥ 95 %, pénalités si raté',
        '📅 Durée : 6/12/24 mois + renouvellement automatique',
      ],
      note: 'Plus le volume engagé est élevé, plus la grille tarifaire est avantageuse pour le client (et la marge stable pour Baobab).',
    },
    { type: 'steps', title: 'Créer un contrat-cadre', steps: [
      { title: 'Page Contrats → "+ Nouveau"', detail: 'Accès limité aux rôles cfo / admin / commercial senior.' },
      { title: 'Sélectionner le client', detail: 'Doit être en statut "Privilégié" ou validé par CFO.' },
      { title: 'Définir le périmètre', detail: 'Trajets autorisés, types véhicules, marchandises éligibles.' },
      { title: 'Saisir la grille tarifaire', detail: 'Tableau : palier volume → prix unitaire.' },
      { title: 'Configurer les SLA', detail: 'Taux service min, pénalités, modalités de calcul.' },
      { title: 'Envoyer pour signature électronique', detail: 'Le client signe via DocuSign ou équivalent.' },
    ]},
    { type: 'comparison', title: 'Bonnes pratiques de contrat', do: [
      'Volume engagé = 80 % du volume historique du client (réaliste)',
      'Grille dégressive avec 3-4 paliers maximum',
      'Pénalités proportionnelles, jamais punitives',
      'Clause d\'évolution annuelle indexée',
      'Réunion trimestrielle de revue contractuelle',
    ], dont: [
      'Ne pas surestimer le volume engagé (le client ne tiendra pas)',
      'Ne pas créer une grille trop complexe (> 5 paliers)',
      'Ne pas oublier les clauses d\'incident (force majeure)',
      'Ne pas signer sans validation juridique',
      'Ne pas modifier en cours sans avenant officiel',
    ]},
    { type: 'quiz', title: 'Quiz',
      question: 'Un client signe pour 100 ops/mois. Il en fait 80 sur 3 mois consécutifs. Que faire ?',
      options: [
        'Le résilier immédiatement',
        'Réunion de revue : comprendre la cause, proposer un avenant pour ajuster le volume',
        'Lui facturer comme s\'il avait fait 100',
        'L\'ignorer',
      ],
      answerIndex: 1,
      explanation: 'Un sous-engagement répété est un signal faible. Mieux vaut ajuster le contrat à la réalité que de laisser pourrir la relation.',
    },
    { type: 'takeaways', title: 'À retenir', items: [
      'Contrat = 5 blocs : périmètre, volume, tarif, SLA, durée.',
      'Volume réaliste = 80 % de l\'historique.',
      'Pénalités proportionnelles, jamais punitives.',
      'Revue trimestrielle = relation saine.',
      'Renouvellement préparé J-60.',
    ]},
    { type: 'cta', title: 'Module 04 terminé !', actions: [
      { label: 'Page Contrats', href: '/admin/contracts' },
      { label: 'Catalogue', href: '/docs/admin/training' },
    ]},
  ],
};
export default moduleStaffContrats;
